import React from 'react';
import { useTranslations } from '@lang';
import { FromPriceWrapper, FromWrapper } from './styles';
import { DiscountPrice } from '../DiscountPrice';
import { PriceProps } from '../types';

export const FromPrice = (props: PriceProps) => {
  const { t } = useTranslations();
  return (
    <FromPriceWrapper data-cy="from-price">
      <FromWrapper data-cy="from-wrapper">{t('common.from')}</FromWrapper>{' '}
      <DiscountPrice {...props} />
    </FromPriceWrapper>
  );
};
